"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () { return typeof window === 'object' && window; });
//# sourceMappingURL=isClient.js.map